"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureCoachmark = void 0;
var react_1 = __importStar(require("react"));
var Popper_1 = __importDefault(require("@mui/material/Popper"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var ClickAwayListener_1 = __importDefault(require("@mui/material/ClickAwayListener"));
var Grow_1 = __importDefault(require("@mui/material/Grow"));
var Lang_js_1 = require("../../Lang.js");
var FeatureCoachmark = function (_a) {
    var anchorEl = _a.anchorEl, anchorSelector = _a.anchorSelector, storageKey = _a.storageKey, title = _a.title, body = _a.body, _b = _a.ctaLabel, ctaLabel = _b === void 0 ? (0, Lang_js_1.__)("OK") : _b, onCta = _a.onCta, _c = _a.placement, placement = _c === void 0 ? "right-start" : _c, _d = _a.autoOpen, autoOpen = _d === void 0 ? true : _d;
    var _e = (0, react_1.useState)(null), resolvedAnchor = _e[0], setResolvedAnchor = _e[1];
    var _f = (0, react_1.useState)(false), open = _f[0], setOpen = _f[1];
    // Resolve anchor: prefer explicit anchorEl, otherwise poll by selector
    (0, react_1.useEffect)(function () {
        // If parent gave us an explicit element, use it directly.
        if (anchorEl) {
            setResolvedAnchor(anchorEl);
            return;
        }
        if (!anchorSelector || typeof window === "undefined") {
            return;
        }
        var cancelled = false;
        var attempts = 0;
        var maxAttempts = 15;
        var pollIntervalMs = 200;
        var isVisible = function (el) {
            var rect = el.getBoundingClientRect();
            var style = window.getComputedStyle(el);
            return (rect.width > 0 &&
                rect.height > 0 &&
                style.visibility !== "hidden" &&
                style.display !== "none");
        };
        var tryResolve = function () {
            if (cancelled)
                return;
            var el = document.querySelector(anchorSelector);
            if (el && isVisible(el)) {
                setResolvedAnchor(el);
                return;
            }
            attempts += 1;
            if (attempts < maxAttempts) {
                setTimeout(tryResolve, pollIntervalMs);
            }
        };
        tryResolve();
        return function () {
            cancelled = true;
        };
    }, [anchorEl, anchorSelector]);
    // Open once if not seen before and we have a resolved anchor
    (0, react_1.useEffect)(function () {
        if (!autoOpen)
            return;
        if (!resolvedAnchor)
            return;
        if (typeof window === "undefined")
            return;
        var seen = window.localStorage.getItem(storageKey);
        if (!seen) {
            setOpen(true);
        }
    }, [resolvedAnchor, autoOpen, storageKey]);
    var markSeenAndClose = function () {
        setOpen(false);
        if (typeof window !== "undefined") {
            window.localStorage.setItem(storageKey, "true");
        }
    };
    var handleClose = function () {
        markSeenAndClose();
    };
    var handleCtaClick = function () {
        if (onCta)
            onCta();
        markSeenAndClose();
    };
    if (!resolvedAnchor)
        return null;
    return (react_1.default.createElement(Popper_1.default, { sx: { zIndex: function (theme) { return theme.zIndex.modal + 1; } }, open: open, anchorEl: resolvedAnchor, placement: placement, transition: true, modifiers: [{ name: "offset", options: { offset: [0, 8] } }] }, function (_a) {
        var TransitionProps = _a.TransitionProps;
        return (react_1.default.createElement(ClickAwayListener_1.default, { onClickAway: handleClose },
            react_1.default.createElement(Grow_1.default, __assign({}, TransitionProps),
                react_1.default.createElement(Paper_1.default, { elevation: 6, sx: {
                        p: 1.5,
                        maxWidth: 260,
                        position: "relative",
                        "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 12,
                            left: -6,
                            borderWidth: "6px",
                            borderStyle: "solid",
                            borderColor: "transparent currentColor transparent transparent",
                            color: function (theme) { return theme.palette.background.paper; },
                        },
                    } },
                    react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: { fontWeight: 600, mb: 0.5 } }, title),
                    react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { mb: 1 } }, body),
                    react_1.default.createElement(Button_1.default, { size: "small", onClick: handleCtaClick }, ctaLabel)))));
    }));
};
exports.FeatureCoachmark = FeatureCoachmark;
exports.default = exports.FeatureCoachmark;
